// PackageModal.jsx
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";

export default function PackageModal({ show, onClose, title, children }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      className="
        fixed inset-0 
        z-[9999]         /* ← absolutely highest on the page */
        flex items-center justify-center 
        bg-black bg-opacity-50
      "
    >
      <div
        className="
          bg-white dark:bg-gray-800 
          rounded-2xl shadow-xl 
          w-full max-w-2xl mx-4 p-6 
          relative 
          z-[10000]      /* ← even above the overlay */
        "
      >
        {/* header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold dark:text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition"
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
        </div>

        {/* body */}
        <div className="space-y-6">{children}</div>
      </div>
    </div>,
    document.body
  );
}
